import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './AboutUs.css';

const AboutUs = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Initialize AOS with simpler configuration for mobile
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      disable: window.innerWidth < 768
    });
  }, []);

  return (
    <>
    <Helmet>
      <title>About Us | Protek Consult - 37+ Years of Civil Engineering Excellence in Hyderabad</title>
      <meta name="description" content="Learn about Protek Consult, a leading civil engineering consultancy and architecture firm in Hyderabad with 37+ years of experience. 100+ projects delivered, 250+ client partnerships, and 10+ certifications." />
      <meta name="keywords" content="about Protek Consult, civil engineering firm Hyderabad, architecture firm India, 37 years experience, construction consultancy, infrastructure development company, Protek Consult team" />
      <link rel="canonical" href="https://protekconsult.com/about" />
      <meta property="og:title" content="About Us | Protek Consult - 37+ Years of Civil Engineering Excellence" />
      <meta property="og:description" content="Learn about Protek Consult, a leading civil engineering consultancy and architecture firm in Hyderabad with 37+ years of experience." />
      <meta property="og:url" content="https://protekconsult.com/about" />
    </Helmet>
    <section className="how-it-started">
      <div className="about-heading" data-aos="fade-down">
        <h1>About Us</h1>
      </div>

      <div className="left-content" data-aos="fade-right">
        <h2 className="title">Building the Future of Design</h2>
        <p className="description">
          At Protek Consult, we're passionate about delivering innovative civil engineering and architecture solutions that transform spaces and improve lives. With over 37 years of experience and expertise, we provide expert advice and services in building design, construction, and infrastructure development. Our team of certified professionals ensures meticulous attention to detail, from conceptualization to completion, guaranteeing that every project meets the highest standards of quality, safety, and sustainability. We bridge the gap between creativity and compliance, where designs meet approval due diligence frameworks, ensuring that innovative ideas seamlessly translate into regulatory-compliant realities.
        </p>
      </div>

      <div className="right-content" data-aos="fade-left">
        <div className="how-it-started-image" data-aos="zoom-in-left">
          <img src="/Assets/image1.png" alt="Protek Consult Team" loading="lazy" />
        </div>
        <div className="how-it-started-stats">
          <div className="stat-item">
            <h3>37+</h3>
            <p>Years Experience</p>
          </div>
          <div className="stat-item">
            <h3>100+</h3>
            <p>Projects Delivered</p>
          </div>
          <div className="stat-item">
            <h3>250+</h3>
            <p>Client Partnerships</p>
          </div>
          <div className="stat-item">
            <h3>10+</h3>
            <p>Certifications & Awards</p>
          </div>
        </div>
      </div>

      <div className="mission-vision-container">
        <div className="mission-section" data-aos="fade-up">
          <h2 className="section-title">Our Mission</h2>
          <p className="section-description">
            Our mission is to create structures that are not only aesthetically pleasing but also functional, durable, and sustainable. We're committed to delivering exceptional results, exceeding client expectations, and building long-term relationships.
          </p>
        </div>

        <div className="values-section" data-aos="fade-up" data-aos-delay="200">
          <h2 className="section-title">Our Values</h2>
          <ul className="values-list">
            <li><strong>Quality:</strong> We strive for excellence in every project.</li>
            <li><strong>Safety:</strong> We prioritize the well-being of our clients, team, and community.</li>
            <li><strong>Sustainability:</strong> We design and build with the environment in mind.</li>
            <li><strong>Innovation:</strong> We stay ahead of the curve with the latest technologies and trends.</li>
          </ul>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutUs;
